import * as React from "react";
import { Alert, Box, Stack, Typography } from "@mui/material";
import "@chatscope/chat-ui-kit-styles/dist/default/styles.min.css";
import {
  MainContainer,
  ChatContainer,
  MessageList,
  Message,
  MessageSeparator,
} from "@chatscope/chat-ui-kit-react";
import { Project } from "../../types/project";
import { useGetChatMessagesQuery } from "../../services/chat.service";
import { useCurrentUser } from "../../hooks/useCurrentUser";
import dayjs from "dayjs";
import { LoadingButton } from "@mui/lab";
import { Refresh } from "@mui/icons-material";
import { CardBase } from "../../components/global";

const ProjectMessagesPanel = ({ project }: { project: Project; }) => {
  const user = useCurrentUser();
  const chatId = project.chats?.[0]?.id || 0;

  const { data, isLoading, isFetching, refetch, isError, error } =
    useGetChatMessagesQuery({
      chatId,
    });

  const Messages = React.useMemo(() => {
    let lastDate = "";
    return data?.data
      ?.slice(0)
      .reverse()
      .map((it) => {
        let curDate = dayjs(it.created_at).format("MMM DD, YYYY");
        let isNewDay = curDate != lastDate;
        if (isNewDay) lastDate = curDate;

        const isImage =
          it.documents?.[0]?.mime_type?.startsWith("image") || false;
        const isFile = !!it.documents?.[0]?.mime_type && !isImage; //anything but image

        return (
          <>
            {isNewDay && <MessageSeparator>{curDate}</MessageSeparator>}
            <Message
              key={it.id}
              model={{
                direction: it.user_id == user?.id ? "outgoing" : "incoming",
                position: "single",
              }}
            >
              {isImage ? (
                // <Message.ImageContent
                //   src={it.documents?.[0]?.original_url}
                //   width={200}
                //   onClick={() => console.log(it.documents?.[0]?.original_url)}
                // />
                <Message.HtmlContent
                  html={`<a href='${it.documents?.[0]?.original_url}' target='_blank'><img src='${it.documents?.[0]?.original_url}' width='250'/></a>`}
                />
              ) : isFile ? (
                <Message.HtmlContent
                  html={`${it.body}<br/><a href='${it.documents?.[0]?.original_url}' target='_blank'>⬇️ Open File</a>`}
                />
              ) : (
                <Message.HtmlContent html={it.body} />
              )}
              <Message.Footer
                sender={`${it.user?.full_name || "?"}`}
                sentTime={dayjs(it.created_at).format("hh:mm A")}
              />
            </Message>
          </>
        );
      });
  }, [data, user]);

  if (isError) {
    return (
      <CardBase useGlassCard={false}>
        <Alert severity="error">
          {/* @ts-ignore */}
          {error?.data?.message || "Failed to load messages"}
        </Alert>
      </CardBase>
    );
  }

  return (
    <CardBase
      title="Messages"
      useGlassCard={false}
      headerActions={
        <LoadingButton
          variant="outlined"
          onClick={refetch}
          size="small"
          loading={isFetching}
          sx={{
            color: "#F4A259",
            "&:hover": {
              backgroundColor: "rgba(244, 162, 89, 0.08)",
              borderColor: "#F4A259",
            },
          }}
          startIcon={<Refresh />}
        >
          Refresh
        </LoadingButton>
      }
      sx={{
        p: 0,
        "& .card-base__content": {
          p: 0,
          height: "calc(62vh + 60px)",
          minHeight: 500,
        },
      }}
    >
      <Box sx={{
        position: "relative",
        height: "62vh",
        minHeight: 500,
        overflow: "hidden",
        borderRadius: 1,
      }}>
        <MainContainer style={{ borderWidth: 0 }}>
          <ChatContainer>
            <MessageList loading={isLoading}>{Messages}</MessageList>
          </ChatContainer>
        </MainContainer>
      </Box>
    </CardBase>
  );
};
export default ProjectMessagesPanel;
